import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function ReleaseNotesPopup() {
  const { isAuthenticated, userInfo } = useAuth();
  const [note, setNote] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const closeRef = useRef(null);
  const token = sessionStorage.getItem('jwtToken');
  const userId = userInfo?.user_id;
  const role = userInfo?.role;

  useEffect(() => {
    let active = true;
    setNote(null); setError(''); setSaving(false);
    if (isAuthenticated && token && ['super_admin', 'locatie_admin'].includes(role)) {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/release-notes/unread`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => { if (active) setNote(response.data.data); })
        // Release notes must never prevent login or use of the application.
        .catch(() => {});
    }
    return () => { active = false; };
  }, [isAuthenticated, userId, role, token]);

  useEffect(() => {
    if (!note) return;
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  }, [note]);

  const dismiss = async () => {
    if (saving) return;
    setSaving(true); setError('');
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/release-notes/${note.release_note_id}/read`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setNote(null);
    } catch { setError('Gelezen-status kon niet worden opgeslagen. Probeer opnieuw.'); }
    finally { setSaving(false); }
  };

  if (!note || !isAuthenticated || !['super_admin', 'locatie_admin'].includes(role)) return null;
  return <div className="modal show d-block" style={{ background: 'rgba(0,0,0,.45)', zIndex: 10000 }} role="dialog" aria-modal="true" aria-labelledby="release-note-title"
    onKeyDown={event => {
      if (event.key === 'Escape') { event.preventDefault(); dismiss(); }
      // There is one action; keep keyboard focus inside the dialog.
      if (event.key === 'Tab') { event.preventDefault(); closeRef.current?.focus(); }
    }}>
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header"><div><small className="text-muted">Nieuw in Mijn Ouderapp</small><h5 className="modal-title" id="release-note-title">{note.title}</h5></div></div>
        <div className="modal-body">
          <p className="small text-muted">{new Date(note.published_at).toLocaleDateString('nl-NL')}</p>
          <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{note.body}</div>
          {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
        </div>
        <div className="modal-footer"><button ref={closeRef} className="btn btn-primary" disabled={saving} onClick={dismiss}>{saving ? 'Opslaan...' : 'Gelezen'}</button></div>
      </div>
    </div>
  </div>;
}
